export default __webpack_public_path__ + "static/media/Asset_Vehicle Import Template - Sheet1.ad53b06c.csv";